import { Box } from "@mui/material";
import startImg from "../../assets/instruction/play_icon.png";
import pauseImg from "../../assets/instruction/pause_icon.png";

function InstructionsEng() {
	return (
		<>
			<Box className="instruction-container">
				<h1>Understanding Your Rights as a Financial Consumer</h1>
				<p style={{ marginTop: "1rem", fontSize: "1rem" }}>
					Hello there! Welcome to Quick Learning Tool No. 6: Understanding Your Rights as a
					Financial Consumer
					<br />
					<br />
					Navigating the financial landscape can be complex, and being aware of your rights is
					empowering.
				</p>
				<br />
				<br />
				<h2>Activity Instructions</h2>
				<p style={{ marginTop: "1rem", fontSize: "1rem" }}>
					Start by clicking on the "Start" button to begin the conversation.
					<br />
					<br />
					At some point, you will be presented with questions related to your rights as a financial
					consumer. Answer the questions to proceed.
					<br />
					<br />
					If you need to pause, click this icon
					<img
						src={pauseImg}
						alt="pasue"
						style={{
							cursor: "pointer",
							marginLeft: "5px",
							height: ".7rem",
						}}
					/>
					. This temporarily stops the current conversation. Click
					<img
						src={startImg}
						alt="start"
						style={{
							cursor: "pointer",
							marginLeft: "5px",
							marginRight: "5px",
							height: ".7rem",
						}}
					/>
					to continue from where you left off.
					<br />
					<br />
					Once done, click “Finish”.
				</p>
			</Box>
		</>
	);
}

export default InstructionsEng;
